import { render, staticRenderFns } from "./widget_waiting_values.vue?vue&type=template&id=5828272d&scoped=true&"
import script from "./widget_waiting_values.vue?vue&type=script&lang=js&"
export * from "./widget_waiting_values.vue?vue&type=script&lang=js&"
import style0 from "./widget_waiting_values.vue?vue&type=style&index=0&id=5828272d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828272d",
  null
  
)

export default component.exports